import { useMemo } from 'react';
import { useDesign } from '../contexts/DesignContext';
import { useGrowthBookValues } from '../contexts/GrowthBookContext';

export const useSteps = () => {
  const { steps: stepVariation, attributeSelectionStyle } =
    useGrowthBookValues();
  const { isNewDesign } = useDesign();

  // Функция для определения, какие шаги показывать
  const getActiveSteps = useMemo(() => {
    // Если не new-design, всегда показываем как было раньше (DEFAULT режим)
    if (!isNewDesign) {
      return (allSteps) =>
        allSteps.filter(
          (step) =>
            step !== 'step4_5' &&
            step !== 'step2_body' &&
            step !== 'step2_breast' &&
            step !== 'step2_ass' &&
            step !== 'step3_hair',
        );
    }

    // Проверяем режим CARROUSEL (работает только для ndg)
    const isCarouselMode = attributeSelectionStyle === 'CARROUSEL';

    // Для new-design проверяем stepVariation
    if (stepVariation === 'SHORT') {
      if (isCarouselMode) {
        // SHORT + CARROUSEL: step2 разбит на 3, убираем step2, step3, step3_hair и step4
        return (allSteps) =>
          allSteps.filter(
            (step) => step !== 'step2' && step !== 'step3' && step !== 'step4',
          );
      }
      // SHORT + DEFAULT: показываем step4_5, убираем step3 и step4 и новые шаги
      return (allSteps) =>
        allSteps.filter(
          (step) =>
            step !== 'step3' &&
            step !== 'step4' &&
            step !== 'step2_body' &&
            step !== 'step2_breast' &&
            step !== 'step2_ass',
        );
    }

    // BASE режим
    if (isCarouselMode) {
      // BASE + CARROUSEL: step2 разбит на 3, показываем step3, убираем step2, step3_hair, step4_5
      return (allSteps) =>
        allSteps.filter(
          (step) => step !== 'step2' && step !== 'step3_hair' && step !== 'step4_5',
        );
    }

    // BASE + DEFAULT: показываем все шаги кроме step4_5 и карусельных body/breast/ass
    return (allSteps) =>
      allSteps.filter(
        (step) =>
          step !== 'step4_5' &&
          step !== 'step2_body' &&
          step !== 'step2_breast' &&
          step !== 'step2_ass' &&
          step !== 'step3_hair',
      );
  }, [stepVariation, attributeSelectionStyle, isNewDesign]);

  // Функция для проверки, является ли режим SHORT
  const isShortMode = useMemo(() => {
    return isNewDesign && stepVariation === 'SHORT';
  }, [stepVariation, isNewDesign]);

  // Функция для проверки, является ли режим CARROUSEL
  const isCarouselMode = useMemo(() => {
    return isNewDesign && attributeSelectionStyle === 'CARROUSEL';
  }, [attributeSelectionStyle, isNewDesign]);

  return {
    stepVariation,
    attributeSelectionStyle,
    getActiveSteps,
    isShortMode,
    isCarouselMode,
  };
};
